// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";

const AdminLogAnalyticsFaqApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/log_analytics_faq";

    const ExecAdminLogAnalyticsFaqApi = async (requestParams) => {
        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url, requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminLogAnalyticsFaqApi;
};

export default AdminLogAnalyticsFaqApi;
